import React, {useState} from 'react'
import {RadioGroupOption} from "./@types"

type Props = {
    className?              : string

    value                   : any
    items                   : RadioGroupOption[]

    disabled?               : boolean
    stateFull?              : boolean       // if true - will use state (!)
    highlightSelectedLabel? : boolean

    onChange                : {(value: any): void}
}

export default function RadioGroup(props: Props) {
    
    const [value, setValue] = useState(props.value)

    const onOptionClick = (value: any) => {
        if (props.disabled) {
            return
        }

        if (props.stateFull) {
            setValue(value)
        }

        props.onChange(value)
    }

    const classes = Classes('ui5-radio-group', props.className, {
        'is-disabled': props.disabled,
    });

    const selectedValue = props.stateFull ? value : props.value

    return (
        <div className={classes}>
            {_.map(props.items, (item: RadioGroupOption)=> {
                const isSelected = item.value === selectedValue
                const selectIconClasses = Classes("ui5-radio s-13 m-r-10", {
                    selected: isSelected
                })

                const labelClasses = Classes("radio-label", {
                    selected: isSelected && props.highlightSelectedLabel
                })

                let icon
                if (item.icon) {
                    const iconClasses = Classes("ui5-ico-14 m-r-5", item.icon, {
                        'action': isSelected && props.highlightSelectedLabel
                    })
                    icon = <div className={iconClasses}/>
                }

                return (
                    <div key        = {item.value}
                         className  = "radio-option"
                         onClick    = {item.disabled ? undefined : () => onOptionClick(item.value)}>
                        <div className="flex-row-left-center h-20">
                            <div className={selectIconClasses}/>
                            {icon}
                        </div>

                        <div className="flex-column-left-top">
                            <div className={labelClasses}>
                                <div className="label ui5-txt-default">{item.label}</div>

                                {item.iconRight &&
                                    <div className={Classes("label-icon-right", item.iconRight)}/>}
                            </div>

                            {!!item.description &&
                                <div className="radio-description ui5-txt-not-important-small m-t-8">
                                    {item.description}
                                </div>}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}